module.exports = __webpack_public_path__ + "img/bg18.96992154.png";